import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
export const DirectionsRenderer = ({ directions, options, }) => {
    const map = useMap();
    useEffect(() => {
        if (!map)
            return undefined;
        const renderer = new google.maps.DirectionsRenderer(Object.assign(Object.assign({}, options), { directions }));
        renderer.setMap(map);
        return () => {
            renderer.setMap(null);
        };
    }, [map, directions, options]);
    return null;
};
